import React from "react";

const LoadingState = ({ label = "Loading Bots..." }) => (
  <div className="flex min-h-[240px] items-center justify-center rounded-2xl border border-dashed border-slate-200 bg-white px-6 py-12 text-center">
    <div className="space-y-4">
      <div className="mx-auto h-10 w-10 animate-spin rounded-full border-2 border-slate-200 border-t-[#096dea]" />
      <p className="text-sm font-medium text-slate-600">{label}</p>
    </div>
  </div>
);

export default LoadingState;
